var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfClosedFist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 49.0301H99.03V26.0601L122 49.0301Z",
    fill: "#E9AF34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49.0301H99.03V26.0601L122 49.0301Z",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.05 71.1201C92.05 70.5201 87.55 71.1801 82.67 72.5201C79.4586 70.3886 76.4223 68.0043 73.59 65.3901C74.02 60.3301 73.83 55.8201 72.79 52.7701C71.4 48.9301 68.71 47.0401 64.93 48.3801C61.34 49.6001 60.17 52.6501 61.39 56.3101C62.55 59.4201 65.48 63.2601 69.26 66.9801C68.7514 70.9707 67.9763 74.9229 66.94 78.8101C62.31 81.1801 58.41 83.8101 56.21 86.4901C53.35 89.7201 52.86 93.6201 55.97 95.6401C64.44 101.3 69.13 86.1201 70.48 81.6401C74.1954 79.8443 78.0475 78.3463 82 77.1601C85.84 79.4801 89.68 81.3101 92.55 81.7901C96.55 82.4601 99.38 81.3101 100.05 77.4101C100.66 74.1701 98.71 71.8001 95.05 71.1201ZM58.65 92.4701C56.21 90.3901 63.65 85.4701 65.05 84.6601C64.56 86.0001 61 94.4101 58.65 92.4701ZM66.21 52.3401C69.57 51.1901 69.57 59.6601 69.57 61.3401C68.53 60.1501 62.73 53.4401 66.21 52.3401ZM71.88 76.4301C72.25 74.4301 72.55 72.5201 72.88 70.5201C74.4 71.8001 75.88 72.9501 77.51 74.1701C75.5861 74.8 73.7054 75.555 71.88 76.4301ZM95.88 76.6701C95.4 79.2301 88.99 76.1801 87.78 75.5201C88.89 75.3901 96.27 74.0501 95.9 76.6701H95.88Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.77 115.41H37.53C36.0634 115.41 34.6568 114.827 33.6197 113.79C32.5826 112.753 32 111.347 32 109.88V33.3501C32 31.8834 32.5826 30.4768 33.6197 29.4398C34.6568 28.4027 36.0634 27.8201 37.53 27.8201H98.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.59 49.3501V109.88C119.587 111.346 119.004 112.751 117.967 113.787C116.931 114.824 115.526 115.407 114.06 115.41",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.4 109.34C104.4 109.34 104.65 105.12 107.16 105.83C110.08 106.52 108.07 116.93 107.3 119.83C106.53 122.73 103.55 126.62 103.55 126.62V129.92H100.46L98.1899 126.62",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.93 126.64L94.45 129.94H87.68V126.64C87.68 126.64 78.2 118.09 80.43 114.4C82.23 111.51 85.25 114.77 85.25 114.77",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.51 109.08C92.51 109.08 91.28 103.43 93.82 103.21C96.36 102.99 96.11 108.82 96.11 108.82",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.02 114.79V122.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.66 114.79V122.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.29 114.79V122.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.51 113.72C86.51 113.72 84.51 106.03 86.91 105.22C89.31 104.41 90.19 109.08 90.19 109.08",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4301 108.82C98.4301 108.82 98.5601 103.53 100.77 103.82C102.98 104.11 102.08 108.97 102.08 108.97",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfClosedFist);
export default __webpack_public_path__ + "static/media/pdf_closed_fist.ed8ca35e2a4bc744ee6b720e7f8605f6.svg";
export { ForwardRef as ReactComponent };